(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["artwork-gallery"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.artwork-gallery-section').forEach(function (section) {
    var buttons = section.querySelectorAll('.artwork-gallery__filter');
    var items = section.querySelectorAll('.artwork-gallery__item');

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        buttons.forEach(function (b) {
          b.classList.remove('is-active');
        });
        button.classList.add('is-active');

        var filter = button.dataset.filter;

        items.forEach(function (item) {
          var show = filter === 'all' || item.dataset.type === filter;
          item.hidden = !show;
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-artwork-post"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-back-to-gallery]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      var galleryPath = link.pathname;
      var referrerPath = document.referrer ? new URL(document.referrer).pathname : '';

      // Only replay history when we actually came from the gallery page itself.
      // A language switch reloads the current article at the same path, which would
      // otherwise make history.back() return to the article instead of the gallery.
      if (referrerPath === galleryPath && window.history.length > 1) {
        event.preventDefault();
        window.history.back();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
  (function () {
    var STORAGE_KEY = 'newsletter-popup-dismissed';

    if (localStorage.getItem(STORAGE_KEY)) return;

    var popup = document.getElementById('newsletter-popup');
    if (!popup) return;

    var delay = (parseInt(popup.dataset.delay, 10) || 5) * 1000;

    function markDismissed() {
      localStorage.setItem(STORAGE_KEY, '1');
    }

    popup.addEventListener('dialog:close', markDismissed);

    customElements.whenDefined('dialog-component').then(function () {
      setTimeout(function () {
        if (!localStorage.getItem(STORAGE_KEY) && typeof popup.showDialog === 'function') {
          popup.showDialog();
        }
      }, delay);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
